import { createIcon } from '../createIcon';
import { ReactComponent as IconSearch } from '../svg/search.svg';

export default createIcon(IconSearch);
